/*=========================================================================================
  File Name: moduleReservedMedicalPackageActions.js
  Description: ReservedMedicalPackage Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"

export default {
  AddReservedMedicalPackage({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post("api/ReservedMedicalPackage/AddReservedMedicalPackage", item)
        .then((response) => {
          commit('ADD_ITEM', Object.assign(item, { ID: response.data.Data.ID }))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  SearchReservedPackage({ commit },search) {
    return new Promise((resolve, reject) => {
      axios.post("api/ReservedMedicalPackage/SearchReservedPackage",search)
        .then((response) => {
          commit('SET_ReservedPackage', response.data.Data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  UpdateReservedMedicalPackage({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post("api/ReservedMedicalPackage/UpdateReservedMedicalPackage", item)
        .then((response) => {
          commit('UPDATE_ReservedMedicalPackage', item)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  GetReservedMedicalPackage({ commit }, itemid) {
    return new Promise((resolve, reject) => {
      axios.get("api/ReservedMedicalPackage/GetReservedMedicalPackage?reservedPackageID="+ itemid)
        .then((response) => {
         
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  DeleteReservedMedicalPackage({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.delete("api/ReservedMedicalPackage/DeleteReservedMedicalPackage?ID="+item.ID)
        .then((response) => {
          commit('REMOVE_ITEM', item.ID)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  CancelReservedMedicalPackage ({ commit }, item) {
    debugger;
    return new Promise((resolve, reject) => {
      axios.post("api/ReservedMedicalPackage/CancelReservedMedicalPackage?reservedPackageID="+item)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
}
